import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryCustomerAttributeGroups = () => {
  const survey = useMainQueryData()

  return React.useMemo(
    () => survey?.customerAttributeGroups ?? [],
    [survey?.customerAttributeGroups],
  )
}
